import "./SimpleWidgetBox.css";

const SimpleWidgetBox = ({ children, className, title }) => {
  return (
    <div className={`region-container ${className}`}>
      <div className={`region-header ${className}`}>
        <div className={`region-title App-title-widgets ${className}`}>
          {title}
        </div>
      </div>
      {children}
    </div>
  );
};

export default SimpleWidgetBox;
